// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__25WKc","choiceBoxes":"toolbarselects_choiceBoxes__1ubH1","simpleField":"toolbarselects_simpleField__2G6vW"};